import { FC } from "react";

import { Box, Flex, VStack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Image from "@components/Image";
import responsiveStyle from "@lib/theme/responsiveStyle";
import { PACKAGE_SIZE_OPTION_NAME } from "@utils/constants/qa";

import { FIXED_DESCRIPTION_PACKAGE_SIZE } from "../../constants";

type TPackageSizeCardProps = {
  title: string;
  description: string;
  image?: string | null;
  activeImage?: string | null;
  weight: string;
  isActive: boolean;
};

const PackageSizeCard: FC<TPackageSizeCardProps> = ({ title, description, image, activeImage, weight, isActive }) => {
  const { t } = useTranslation();

  const content =
    isActive && title !== FIXED_DESCRIPTION_PACKAGE_SIZE ? (
      <Flex align="center">
        {weight && (
          <>
            <Icon icon="weight" size="1rem" mr="0.25rem" /> {description}
          </>
        )}
      </Flex>
    ) : (
      <Box maxHeight="2.5rem" overflow="hidden" textOverflow="ellipsis" title={description}>
        {description}
      </Box>
    );

  const imageSrc = isActive ? activeImage : image;

  return (
    <VStack
      spacing="0.25rem"
      justify="space-between"
      alignSelf="stretch"
      pt="0.75rem"
      pb="0.5rem"
      width="full"
      overflow="hidden"
    >
      <Box width="100%">
        <Box data-testid={PACKAGE_SIZE_OPTION_NAME}>{title}</Box>
        <Box
          width="100%"
          height={responsiveStyle({ mobile: "2.6rem", desktop: "4.125rem" })}
          position="relative"
          mt="0.7rem"
        >
          {imageSrc && <Image src={imageSrc} alt={title} fill={true} />}
        </Box>
      </Box>
      <Flex whiteSpace="initial" fontSize="0.75rem" align="flex-end" justify="center" width="full">
        {content}
      </Flex>
    </VStack>
  );
};
export default PackageSizeCard;
